// src/services/virtual.js
export async function runVirtualOnce(payload={}){
  const base = process.env.REACT_APP_API_URL;
  const r = await fetch(`${base}/virtual/run_once`,{
    method: "POST", headers: {"Content-Type":"application/json"}, body: JSON.stringify(payload)
  });
  if(!r.ok) throw new Error(`HTTP ${r.status}`);
  return r.json();
}
export async function backtestVirtual(payload={}){
  const base = process.env.REACT_APP_API_URL;
  const r = await fetch(`${base}/virtual/backtest`,{
    method: "POST", headers: {"Content-Type":"application/json"}, body: JSON.stringify(payload)
  });
  if(!r.ok) throw new Error(`HTTP ${r.status}`);
  return r.json();
}
